import { IModel, IAttribute } from '../base/annotation';
import { Metamodel } from '../base/model';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { FormatDatasetV2 } from './dataset.v2';
import { format } from '../../shared/utils/string.util';
import { ModelConstants } from '../model-constants';

@Metamodel.model({
    name: ModelConstants.parquetDataset,
    display: [
        format(shellStringResources.ModelName_DatasetTemplate, shellStringResources.ModelName_ParquetDataset),
        format(shellStringResources.ModelName_DatasetsTemplate, shellStringResources.ModelName_ParquetDataset)
    ]
})
export class ParquetDataset extends FormatDatasetV2 {
    public static readonly MODEL: IModel;
    public static readonly COMPRESSION_CODEC: IAttribute;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_CompressionCodec,
        association: 'COMPRESSION_CODEC',
        templatable: true
    })
    public compressionCodec?: string = 'snappy';

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
